import React from 'react';
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  TextField,
  Button,
  Autocomplete,
} from '@mui/material';
import { BudgetFormData } from '../../types';

interface GenericBudgetModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  currencies: string[];
  formData: BudgetFormData;
  setFormData: (data: BudgetFormData) => void;
  title?: string;
}

export const GenericBudgetModal: React.FC<GenericBudgetModalProps> = ({
  open,
  onClose,
  onSubmit,
  currencies,
  formData,
  setFormData,
  title,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{
        backdrop: Backdrop,
      }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}>
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: '0 12px 40px rgba(16,35,58,.16)',
            p: 4,
            borderRadius: '14px',
          }}>
          <Typography variant="h6" component="h2" sx={{ mb: 3 }}>
            {title || `Set Budget for ${formData.name}`}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              id="budget-value"
              label="Budget Value"
              variant="outlined"
              fullWidth
              type="number"
              value={formData.original_currency_value}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  original_currency_value: e.target.value,
                })
              }
              inputProps={{ 'data-testid': 'set-budget-value' }}
            />

            <Autocomplete
              id="combo-box-currencies"
              disablePortal
              getOptionLabel={(option: any) => option}
              options={currencies ?? []}
              disabled  // disabled for now until currency and value are checked in backend
              value={formData.original_currency ?? null}
              onChange={(e, value) => {
                if (value) {
                  setFormData({
                    ...formData,
                    original_currency: value,
                  });
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Currency" variant="outlined" />
              )}
            />

            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <Button
                variant="contained"
                onClick={onSubmit}
                color="primary"
                fullWidth>
                Set Budget
              </Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};
